<template>
  <div class="circuit-breaker">
    <div>
      <b-checkbox
        class="circuit-breaker__title mt-0"
        :checked="isAllFieldsSelected('generalData', true)"
        @change="toggleAll($event, 'generalData', true)"
      >
        {{ $t('asset-information.menu.general-data') }}
      </b-checkbox>
    </div>
    <b-checkbox-group
      class="circuit-breaker__checkbox-group"
      v-model="selectedFieldsProxy"
      :options="generalData.firstGeneralSection"
    />
    <fieldset class="circuit-breaker__fieldset">
      <legend class="circuit-breaker__legend">
        {{ $t('fields.asset.circuit-breaker.interruption-capability') }}
      </legend>
      <b-checkbox-group
        class="circuit-breaker__checkbox-group"
        v-model="selectedFieldsProxy"
        :options="generalData.interruptionCapability"
      />
    </fieldset>
    <b-checkbox-group
      class="circuit-breaker__checkbox-group"
      v-model="selectedFieldsProxy"
      :options="generalData.secondGeneralSection"
    />
    <fieldset class="circuit-breaker__fieldset">
      <legend class="circuit-breaker__legend">
        {{ $t('fields.asset.circuit-breaker.supportable-nominal-chain') }}
      </legend>
      <b-checkbox-group
        class="circuit-breaker__checkbox-group"
        v-model="selectedFieldsProxy"
        :options="generalData.supportableNominalChain"
      />
    </fieldset>
    <b-checkbox-group
      class="circuit-breaker__checkbox-group"
      v-model="selectedFieldsProxy"
      :options="generalData.thirdGeneralSection"
    />
  </div>
</template>

<script>
import circuitBreakerTabFields from '@/domain/data/generalPanel/reports/additionalFields/circuitBreakerTabFields';
import additionalFieldsTabMixin from '@/domain/data/generalPanel/reports/additionalFields/additionalFieldsTabMixin';

export default {
  name: 'CircuitBreakerTab',
  mixins: [additionalFieldsTabMixin],
  props: {
    selectedFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data: vm => ({
    fields: circuitBreakerTabFields(vm),
  }),
  computed: {
    generalData() {
      return this.fields.generalData || {};
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.circuit-breaker
  max-height: 57vh
  overflow-y: auto
  &__fieldset
    margin: 10px
    padding: 5px 0
    border: 1px solid $color-border-gray
    border-radius: 3px
    .circuit-breaker__checkbox-group ::v-deep
      .custom-control.custom-control-inline.custom-checkbox
        width: 225px
  &__legend
    font-size: 1rem
    font-weight: bold
    margin-left: 10px
    padding: 0 5px
    margin-bottom: 0
    width: auto
  &__title
    background-color: var(--color-background-dark)
    color: var(--font-color-primary)
    padding-left: 30px
    max-height: unset
    height: 30px
    display: flex
    align-items: center
    margin: 10px 0
  &__checkbox-group
    margin-left: 9px
    ::v-deep
      .custom-control-label
        font-weight: normal
      div:last-child
        width: unset !important
      > div
        min-height: 50px
        max-height: unset
        align-items: center
        width: 230px

</style>
